import { render } from "./MultiSelectedFlight.vue?vue&type=template&id=56256f22&scoped=true"
import script from "./MultiSelectedFlight.vue?vue&type=script&lang=js"
export * from "./MultiSelectedFlight.vue?vue&type=script&lang=js"

import "./MultiSelectedFlight.vue?vue&type=style&index=0&id=56256f22&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56256f22"]])

export default __exports__